var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"pt-3",attrs:{"id":"simulator"}},[_c('Description'),_c('Calculator')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }